// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  addedProducts: [],
  colors: {},
  panelsList: {},
  types: {},
  heights: {},
  postsList: {},
  cornerPostsList: {},
  accessoryList: {},
  cornerPostAccessoryList: {},
  cornerAccessoryList: {},
  treeStructureSettings: {
    level: 0,
    parentId: null,
    parentName: null,
  },
  inputDataToSend: {
    panelIRI: '',
    postIRI: '',
    accessories: [],
    accessoriesFlat: [],
    corners: 0,
    openings: 0,
  },
  necessaryProductsQuantity: {},
};
